<template>
  <v-form ref="listCompanyForm">
    <v-container>
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2"
            >Are you sure?</v-card-title
          >
          <v-card-text>Are you sure you want delete users?</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Yes</v-btn>
            <v-btn color="primary" text @click="dialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col class="text-right">
        <v-btn :to="'company/create'" class="primary" small>Add</v-btn>
        <v-btn @click="deactiveCompany"  class="ml-2" small color="#eee">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
        <v-btn @click="$refreshDataTable" class="ml-2" small color="#eee">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
      <!-- Datatable -->
      <datatable
        ref="company_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
      />
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  created () {
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getCompanyAll',
        editUrl: 'company/edit',
        deleteRoute: 'deactiveCompany',
        moduleName: 'company',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Address', value: 'address' },
          { text: 'GST', value: 'gst' },
          { text: 'Subscription Start Date', value: 'sub_start_date' },
          { text: 'Subscription End Date', value: 'sub_end_date' },
          { text: 'User Count', value: 'user_count' },
          { text: 'Welder Count', value: 'welder_count' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        }
      },
    }
  },
  watch: {
    options: {
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveCompany () {
      this.$refs.company_datatable.massDeleteTableData()
    },
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
</style>
